<div id="divDialogContent" mat-dialog-content [formGroup]="frmNameAndNumberKey">
  <!-- start of sku name  -->
  <div [hidden]="rowdata && rowdata.disable_for=='name'">
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
      <div fxFlex="20">
        <p>
          {{ "module-assignment.femaleShirtAndShort.search_by_SKU_for_name" | translate }}
        </p>
      </div>
      <div fxFlex="30" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px grid">
        <mat-form-field floatLabel="never">
          <!-- <mat-select
          id="filterBySkuCtrl"
          formControlName="filterByCtrl"
          [placeholder]="'Please select'"
        >
          <mat-option value="search_By_Name" *ngIf="rowdata && rowdata.disable_for!='name'"
            >Search By Name
          </mat-option>
          <mat-option value="search_By_Number" *ngIf="rowdata && rowdata.disable_for!='number'"
            >Search By Number</mat-option
          >
        </mat-select> -->
          <input
            type="text"
            matInput
            formControlName="skuByIdForName"
            [placeholder]="'module-assignment.shirtPrint.searchById' | translate"
            (keyup)="onSearchInput($event)"
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            type="text"
            matInput
            formControlName="skuByNameForName"
            [placeholder]="'module-assignment.shirtPrint.searchByName' | translate"
            (keyup)="onSearchInput($event)"
          />
        </mat-form-field>
      </div>
    </div>
    <!-- <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
    <div fxFlex="20">
      <p>
        {{ "module-assignment.femaleShirtAndShort.search" | translate }}
      </p>
    </div>
    <div fxFlex="30">
      <mat-form-field floatLabel="never">
        <input
          type="text"
          matInput
          formControlName="filterBySkuCtrl"
          [placeholder]="'module-assignment.hotkeys.sku' | translate"
          (keyup)="onSearchInput($event)"
        />
      </mat-form-field>
    </div>
  </div> -->

    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
      <div fxFlex="100">
        <mat-card>
          <mat-card-content>
            <div
              fxLayout="row wrap"
              fxLayoutGap="20px grid"
              class="u-margin-top-15 u-margin-bottom-15"
            >
              <div fxFlex="100">
                <table mat-table #ebasketNameTable [dataSource]="skuTableDataForName" matSort>
                  <ng-container matColumnDef="SKU_ID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ "module-assignment.femaleShirtAndShort.skuID" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.SKU }}</td>
                  </ng-container>
                  <ng-container matColumnDef="SKU_Name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ "module-assignment.femaleShirtAndShort.skuName" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{element.descriptions && element.descriptions.length > 0 &&
                      element.descriptions[0].value ? element.descriptions[0].value : ''}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ "module-assignment.hotkeys.action" | translate }}
                    </th>
                    <!-- <mat-radio-group
                          aria-label="Select an option"
                          id="rdGroupDrawer"
                          formControlName="sku"
                        > -->
                    <td mat-cell *matCellDef="let element;">
                      <input
                        type="radio"
                        formControlName="skuRadioForName"
                        [value]="element"
                        (change)="selectSKUForName(element)"
                        [checked]="element.isChecked"
                      />
                      <!-- <mat-radio-button value="element" id="matRadioOption{{i}}">
                    </mat-radio-button
                    > -->
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="nameAndNumbersColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: nameAndNumbersColumns;"></tr>
                </table>

                <mat-paginator
                  #paginatorForName
                  [pageSizeOptions]="pageSizeOptions"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  <!-- end of sku name -->
  <!-- start of sku number  -->
  <div [hidden]="rowdata && rowdata.disable_for =='number'">
    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
      <div fxFlex="20">
        <p>
          {{ "module-assignment.femaleShirtAndShort.search_by_SKU_for_number" | translate }}
        </p>
      </div>
      <div fxFlex="30" fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px grid">
        <mat-form-field floatLabel="never">
          <!-- <mat-select
          id="filterBySkuCtrl"
          formControlName="filterByCtrl"
          [placeholder]="'Please select'"
        >
          <mat-option value="search_By_Name" *ngIf="rowdata && rowdata.disable_for!='name'"
            >Search By Name
          </mat-option>
          <mat-option value="search_By_Number" *ngIf="rowdata && rowdata.disable_for!='number'"
            >Search By Number</mat-option
          >
        </mat-select> -->
          <input
            type="text"
            matInput
            formControlName="skuByIdForNumber"
            [placeholder]="'module-assignment.shirtPrint.searchById' | translate"
            (keyup)="onSearchInput($event)"
          />
        </mat-form-field>
        <mat-form-field floatLabel="never">
          <input
            type="text"
            matInput
            formControlName="skuByNameForNumber"
            [placeholder]="'module-assignment.shirtPrint.searchByName' | translate"
            (keyup)="onSearchInput($event)"
          />
        </mat-form-field>
      </div>
    </div>
    <!-- <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
    <div fxFlex="20">
      <p>
        {{ "module-assignment.femaleShirtAndShort.search" | translate }}
      </p>
    </div>
    <div fxFlex="30">
      <mat-form-field floatLabel="never">
        <input
          type="text"
          matInput
          formControlName="filterBySkuCtrl"
          [placeholder]="'module-assignment.hotkeys.sku' | translate"
          (keyup)="onSearchInput($event)"
        />
      </mat-form-field>
    </div>
  </div> -->

    <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
      <div fxFlex="100">
        <mat-card>
          <mat-card-content>
            <div
              fxLayout="row wrap"
              fxLayoutGap="20px grid"
              class="u-margin-top-15 u-margin-bottom-15"
            >
              <div fxFlex="100">
                <table mat-table #ebasketNumbersTable [dataSource]="skuTableDataForNumber" matSort>
                  <ng-container matColumnDef="SKU_ID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ "module-assignment.femaleShirtAndShort.skuID" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.SKU }}</td>
                  </ng-container>
                  <ng-container matColumnDef="SKU_Name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ "module-assignment.femaleShirtAndShort.skuName" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{element.descriptions && element.descriptions.length > 0 &&
                      element.descriptions[0].value ? element.descriptions[0].value : ''}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                      {{ "module-assignment.hotkeys.action" | translate }}
                    </th>
                    <!-- <mat-radio-group
                          aria-label="Select an option"
                          id="rdGroupDrawer"
                          formControlName="sku"
                        > -->
                    <td mat-cell *matCellDef="let element;">
                      <input
                        type="radio"
                        formControlName="skuRadioForNumber"
                        [value]="element"
                        (change)="selectSKUForNumber(element)"
                        [checked]="element.isChecked"
                      />
                      <!-- <mat-radio-button value="element" id="matRadioOption{{i}}">
                    </mat-radio-button
                    > -->
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="nameAndNumbersColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: nameAndNumbersColumns;"></tr>
                </table>

                <mat-paginator
                  #paginatorForNumber
                  [pageSizeOptions]="pageSizeOptions"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
  <!-- end of sku number  -->
</div>
<div style="color:red" *ngIf="rowdata && rowdata.disable_for == ''">
  <span> {{ "module-assignment.femaleShirtAndShort.name_and_num_mandatory" | translate }} </span>
</div>
<div id="divDialogAction" mat-dialog-actions class="pull-right">
  <button
    id="btnYes"
    mat-flat-button
    mat-dialog-close="yes"
    cdkFocusInitial
    color="primary"
    [disabled]="frmNameAndNumberKey.invalid"
    (click)="onSave()"
  >
    {{'module-assignment.hotkeys.ok' | translate}}
  </button>
  <button id="btnNo" mat-flat-button mat-dialog-close="no" color="warn" (click)="onCancel()">
    {{'module-assignment.hotkeys.cancel' | translate}}
  </button>
</div>
